module.exports = __webpack_public_path__ + "img/state2.aaef40d2.png";